export type DateOnlyIso = `${number}-${number}-${number}`;

export type ClosingTimeRequestAction = "CREATE" | "UPDATE" | "DELETE";

export type ClosingTimeRequest = {
  "@id": string;
  "@type": string;
  id: number;
  action: ClosingTimeRequestAction;
  editedBy: string;
  name?: string | null;
  startDate?: DateOnlyIso | null;
  endDate?: DateOnlyIso | null;
  closingTime?: string | null;
  schoolClass?: string | null;
  createdAt?: string;
  updatedAt?: string;
};

export type CreateClosingTimeRequestInput = {
  action: "CREATE";
  name: string;
  startDate: DateOnlyIso;
  endDate: DateOnlyIso;
  editedBy: string;
  schoolClass?: string;
};

export type UpdateClosingTimeRequestInput = {
  action: "UPDATE";
  name: string;
  startDate: DateOnlyIso;
  endDate: DateOnlyIso;
  editedBy: string;
  closingTime: string;
  schoolClass?: string;
};

export type DeleteClosingTimeRequestInput = {
  action: "DELETE";
  name: string;
  startDate: DateOnlyIso;
  endDate: DateOnlyIso;
  editedBy: string;
  closingTime: string;
  schoolClass?: string;
};

export type ClosingTimeRequestInput =
  | CreateClosingTimeRequestInput
  | UpdateClosingTimeRequestInput
  | DeleteClosingTimeRequestInput;
